import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from "react";
import { components } from "react-select";
import ChipCheckbox from "../../../../../Chip/components/Checkbox";
import MetaLabel from "../../../../../Chip/components/MetaLabel";
import { BaseChipLabelContainer } from "../../../../../Chip/styled";
import ConditionalTooltipWrapper from "../../../../../helpers/components/ConditionalTooltipWrapper";
import { EMPTY_OBJ } from "../../../../../helpers/logic/empties";
import useForceUpdate from "../../../hooks/useForceUpdate";
import useMultiValueLabelCheckbox from "./hooks/useMultiValueLabelCheckbox";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var MultiValueLabel = components.MultiValueLabel;
function ChipMultiValueLabel(props) {
  var data = props.data,
    selectProps = props.selectProps;
  var metaLabelProps = data.metaLabelProps,
    chipCheckboxProps = data.chipCheckboxProps,
    tooltipContent = data.tooltipContent;
  var _ref = chipCheckboxProps || EMPTY_OBJ,
    onCheckboxClick = _ref.onClick;
  var _useForceUpdate = useForceUpdate(),
    _useForceUpdate2 = _slicedToArray(_useForceUpdate, 1),
    forceUpdate = _useForceUpdate2[0];
  var _useMultiValueLabelCh = useMultiValueLabelCheckbox({
      data: data,
      selectProps: selectProps,
      onCheckboxClick: onCheckboxClick,
      forceUpdate: forceUpdate
    }),
    handleCheckboxClick = _useMultiValueLabelCh.handleCheckboxClick;
  return /*#__PURE__*/_jsx(ConditionalTooltipWrapper, {
    tooltipContent: tooltipContent,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(BaseChipLabelContainer, {
        children: [/*#__PURE__*/_jsx(MultiValueLabel, _extends({}, props)), metaLabelProps && /*#__PURE__*/_jsx(MetaLabel, _extends({}, metaLabelProps))]
      }), chipCheckboxProps && /*#__PURE__*/_jsx(ChipCheckbox, _extends({}, chipCheckboxProps, {
        onClick: handleCheckboxClick
      }))]
    })
  });
}
export default ChipMultiValueLabel;